// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--WyXTBOW1uWMO2bye","wrapperRedesigned":"wrapper_redesigned--eB8nU_ZAA0Dsxgyt","titleRow":"title-row--Zg55iMPk3hAppfyp","title":"title--k3v1I_omddAeFTQv"};